/**
 * Shared utilities for access management components
 */

export const getAccessLevelBadgeVariant = (level) => {
  switch (level) {
    case 'admin':
      return 'danger';
    case 'write':
      return 'warning';
    case 'read':
      return 'success';
    default:
      return 'gray';
  }
};

export const getAccessSourceIcon = (source) => {
  switch (source) {
    case 'company':
      return '🏢';
    case 'admin_role':
      return '👑';
    case 'direct':
      return '👤';
    case 'role':
      return '🎭';
    default:
      return '•';
  }
};

export const getAccessSourceLabel = (source) => {
  switch (source) {
    case 'company':
      return 'Company Access';
    case 'admin_role':
      return 'Admin Role';
    case 'direct':
      return 'Direct Assignment';
    case 'role':
      return 'Role-Based';
    default:
      return source;
  }
};

export const getUserRoleBadgeVariant = (role) => {
  switch (role) {
    case 'admin':
      return 'danger';
    case 'supervisor':
      return 'warning';
    default:
      return 'gray';
  }
};
